module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-group-half-c65d1e206c4f0aaf77ec911bde748be2.svg";